var _classCallCheck = require("/Users/tamir/work/websites/markidim/markidim_web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/tamir/work/websites/markidim/markidim_web/node_modules/@babel/runtime/helpers/createClass");

/**
* App service
*
* This is a singleton class which can be used to store
* common data such as the currently logged in user.
*/
var Rx = require('rx');

var instance = null;

var Appinst =
/*#__PURE__*/
function () {
  "use strict";

  /**
  * Singleton constructor
  */
  function Appinst(props) {
    _classCallCheck(this, Appinst);

    // Set up the singleton
    if (!instance) {
      instance = this;
    } // User instance


    this.user = null;
    return instance;
  }
  /**
  * Returns the singleton instance
  * @return {Auth} The Api singleton instance
  */


  _createClass(Appinst, [{
    key: "getUser",
    value: function getUser() {
      return this.user;
    }
  }, {
    key: "setUser",
    value: function setUser(user) {
      this.user = user;
    }
  }, {
    key: "getAccounts",
    value: function getAccounts() {
      return this.accounts;
    }
  }, {
    key: "setAccounts",
    value: function setAccounts(accounts) {
      this.accounts = accounts;
    }
  }, {
    key: "getOrganizations",
    value: function getOrganizations() {
      return this.organizations;
    }
  }, {
    key: "setOrganizations",
    value: function setOrganizations(organizations) {
      this.organizations = organizations;
    }
  }, {
    key: "getPermissionLevel",
    value: function getPermissionLevel() {
      return this.permissionLevel;
    }
  }, {
    key: "setPermissionLevel",
    value: function setPermissionLevel(permissionLevel) {
      this.permissionLevel = permissionLevel;
    }
  }, {
    key: "getFront",
    value: function getFront() {
      return this.front;
    }
  }, {
    key: "setFront",
    value: function setFront(front) {
      this.front = front;
    }
  }, {
    key: "clearUser",
    value: function clearUser() {
      this.user = null;
      this.accounts = null;
      this.organizations = null;
      this.permissionLevel = null;
      this.front = null;
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      return new Appinst();
    }
  }]);

  return Appinst;
}();

module.exports = Appinst;